import React, {useContext, useState} from 'react';
import styles from "./term-sheet-details.module.scss";
import {Button, Col, ProgressBar, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {
  getMannerOfDistribution, getNumberOfSecurity,
  getSecurityForm,
  getSecurityClass,
  getSecurityTypes
} from "../../../../../../helpr/listingFormData";
import {
  TERM_SHEET_CONFIRMED,
  TERM_SHEET_DRAFT,
  TERM_SHEET_REJECTED,
  TERM_SHEET_SUBMITTED
} from "../../../../../../helpr/constants";
import ModalCustom from '../../../../../../components/modal/modal';
import DeleteListingModalContent from '../delete-listing-modal-content/delete-listing-modal-content';
import {IdentityContext} from "../../../../../../context/identity-context";

const TermSheetDetails = ({context}) => {
  //Use history for redirect
  const navigate = useNavigate();
  const { termSheet, computePercentage, editAllowed } = context;
  const { user } = useContext(IdentityContext);
  const username = user.username;

  //Modal State
  const [modalState, setModalState] = useState({
    title: '',
    show: false,
    component: '',
    style: ''
  });

  const renderTypeValue = key => getSecurityTypes({value: key}).filter(t => t.value === key)[0]?
    getSecurityTypes({value: key}).filter(t => t.value === key)[0].name: key;
  const renderClassValue = key => getSecurityClass().filter(t => t.value === key)[0]?
    getSecurityClass().filter(t => t.value === key)[0].name: 'Scripless';
  const renderFormValue = key => getSecurityForm().filter(t => t.value === key)[0]?
    getSecurityForm().filter(t => t.value === key)[0].name: key;
  const renderMannerValue = key => getMannerOfDistribution().filter(t => t.value === key)[0].name;
  const renderNumberValue = key => getNumberOfSecurity().filter(t => t.value === key)[0].name;
  const renderStatus = status => {
    switch(status) {
      case TERM_SHEET_DRAFT:
        return 'Draft - Pending Submission';
      case TERM_SHEET_SUBMITTED:
        return 'Submitted';
      case TERM_SHEET_CONFIRMED:
        return 'Confirmed';
      case TERM_SHEET_REJECTED:
        return 'Rejected';
      default:
    }
  }

  //Modal actions
  const closeModal = () => {
    setModalState(prev => ({
      ...modalState,
      show: false,
      component: '',
      style: prev.style
    }));
  }

  const showDeleteListingModal = () => {
    const component = <DeleteListingModalContent applicationId={termSheet.applicationId} onClose={()=>closeModal()}/>;
    setModalState({
      ...modalState,
      title: 'Delete Termsheet Confirmation',
      show: true,
      component: component,
      style: 'delete-listing-modal'
    });
  }

  return (
    <>
      <div className={`${styles['term-sheet-details']} ${styles['panel']}`}>
        <Row>
          <Col xs={12} lg={6}>
            <div className={styles['table-heading']}>
              Security Terms
            </div>
          </Col>
          { editAllowed() ?
            <Col xs={12} lg={6}>
              <div className={styles['button-row']}>
                {termSheet.applicationStatus === TERM_SHEET_DRAFT || termSheet.applicationStatus === TERM_SHEET_REJECTED ? <Button onClick={() => navigate(`/listing/application/${termSheet.applicationId}?ic=${termSheet.institutionCode}`)} variant="secondary">
                  EDIT
                </Button> : ''}
                { !termSheet.isPublished && ( termSheet.applicationStatus === TERM_SHEET_DRAFT || (termSheet.applicationStatus === TERM_SHEET_REJECTED && termSheet.administerStatus == '0')) ?
                  <Button onClick={() => showDeleteListingModal()} variant="danger">
                    DELETE
                  </Button> : ''}
              </div>
            </Col> : ''
          }
        </Row>
        <Row>
          <Col>
            <div className={styles['term-sheet-status']}>
              Status: {renderStatus(termSheet.applicationStatus)}
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <div>
              <ProgressBar className={styles['progress']} now={computePercentage()} label={`${computePercentage()}%`} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Type: <span className={styles['value']}>{renderTypeValue(termSheet.securityType)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Class: <span className={styles['value']}>{renderClassValue(termSheet.securityClass)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Form: <span className={styles['value']}>{renderFormValue(termSheet.securityForm)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Manner of Distribution: <span className={styles['value']}>{renderMannerValue(termSheet.mannerOfDistrib)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Number of Security: <span className={styles['value']}>{renderNumberValue(termSheet.numberOfSecurity)}</span>
            </div>
          </Col>
        </Row>

      </div>
        <ModalCustom
          show={modalState.show}
          title={modalState.title}
          onClose={() => closeModal()}
          component={modalState.component}
          style={modalState.style ? styles[modalState.style] : ''} />
    </>
  )
}

export default TermSheetDetails;
